export const nfseValidationErrorMappings = {
    NFSE_VALIDATION_COMPANY_JSON_INVALID: {
        code: 'NFSE_VALIDATION_COMPANY_JSON_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Falha na validação dos dados da empresa. Verifique as informações informadas.',
            },
            {
                language: 'en-US',
                message: 'Company data validation failed. Please check the provided information.',
            },
            {
                language: 'es-ES',
                message: 'Error en la validación de datos de la empresa. Verifique la información proporcionada.',
            },
            {
                language: 'pt-BR',
                message: 'Falha na validação dos dados da empresa. Verifique as informações informadas.',
            },
        ],
        technicalMessage: 'Falha na validação do JSON de Empresa',
        severity: 'error',
        critical: false,
    },
    NFSE_TYPE_OF_TAXATION_INVALID: {
        code: 'NFSE_TYPE_OF_TAXATION_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O tipo de tributação do serviço informado é inválido. Selecione uma opção válida.',
            },
            {
                language: 'en-US',
                message: 'The service tax type provided is invalid. Please select a valid option.',
            },
            {
                language: 'es-ES',
                message: 'El tipo de tributación del servicio proporcionado es inválido. Seleccione una opción válida.',
            },
            {
                language: 'pt-BR',
                message: 'O tipo de tributação do serviço informado é inválido. Selecione uma opção válida.',
            },
        ],
        technicalMessage: 'Invalid typeOfTaxation value in NFS-e configuration',
        severity: 'warning',
        critical: false,
    },
    NFSE_VALIDATION_SERIES_MUST_BE_NUMERIC: {
        code: 'NFSE_VALIDATION_SERIES_MUST_BE_NUMERIC',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A série deve ser obrigatoriamente numérica.',
            },
            {
                language: 'en-US',
                message: 'The series must be numeric.',
            },
            {
                language: 'es-ES',
                message: 'La serie debe ser numérica.',
            },
            {
                language: 'pt-BR',
                message: 'A série deve ser obrigatoriamente numérica.',
            },
        ],
        technicalMessage: 'a série precisa ser obrigatoriamente numérica',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_RPS_NUMBER_MIN: {
        code: 'NFSE_VALIDATION_RPS_NUMBER_MIN',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O número do RPS está abaixo do valor mínimo permitido.',
            },
            {
                language: 'en-US',
                message: 'The RPS number is below the minimum allowed value.',
            },
            {
                language: 'es-ES',
                message: 'El número de RPS está por debajo del valor mínimo permitido.',
            },
            {
                language: 'pt-BR',
                message: 'O número do RPS está abaixo do valor mínimo permitido.',
            },
        ],
        technicalMessage: 'nfse_config_rps_numeracao_0_numero deve ser no mínimo',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_CITY_PRODUCTION_UNAVAILABLE: {
        code: 'NFSE_VALIDATION_CITY_PRODUCTION_UNAVAILABLE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Ambiente de Produção não disponível para esta cidade.',
            },
            {
                language: 'en-US',
                message: 'Production environment not available for this city.',
            },
            {
                language: 'es-ES',
                message: 'Ambiente de producción no disponible para esta ciudad.',
            },
            {
                language: 'pt-BR',
                message: 'Ambiente de Produção não disponível para esta cidade.',
            },
        ],
        technicalMessage: 'Ambiente de Produção não disponível para a cidade',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_CITY_NOT_HOMOLOGATED: {
        code: 'NFSE_VALIDATION_CITY_NOT_HOMOLOGATED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Padrão Nacional não homologado para esta cidade.',
            },
            {
                language: 'en-US',
                message: 'National standard not approved for this city.',
            },
            {
                language: 'es-ES',
                message: 'Estándar nacional no aprobado para esta ciudad.',
            },
            {
                language: 'pt-BR',
                message: 'Padrão Nacional não homologado para esta cidade.',
            },
        ],
        technicalMessage: 'Padrão Nacional não homologado para a cidade',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_JSON_INVALID: {
        code: 'NFSE_VALIDATION_JSON_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Falha na validação dos dados. Verifique as informações informadas.',
            },
            {
                language: 'en-US',
                message: 'Data validation failed. Please check the provided information.',
            },
            {
                language: 'es-ES',
                message: 'Error en la validación de datos. Verifique la información proporcionada.',
            },
            {
                language: 'pt-BR',
                message: 'Falha na validação dos dados. Verifique as informações informadas.',
            },
        ],
        technicalMessage: 'PlugNotas: Falha na validação do JSON.',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_INCOMPLETE_DATA: {
        code: 'NFSE_VALIDATION_INCOMPLETE_DATA',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Dados incompletos para gerar a NFSe. Verifique todas as informações necessárias.',
            },
            {
                language: 'pt-BR',
                message: 'Dados incompletos para gerar a NFSe. Verifique todas as informações necessárias.',
            },
            {
                language: 'en-US',
                message: 'Incomplete data to generate NFSe. Please check all required information.',
            },
            {
                language: 'es-ES',
                message: 'Datos incompletos para generar la NFSe. Verifique toda la información necesaria.',
            },
        ],
        technicalMessage: 'Dados para gerar a NFSe incompletos',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_CONFIGURATION_NOT_FINISHED: {
        code: 'NFSE_VALIDATION_CONFIGURATION_NOT_FINISHED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'É necessário finalizar a configuração da NFSe para realizar essa operação.',
            },
            {
                language: 'en-US',
                message: 'It is necessary to complete the NFSe configuration to perform this operation.',
            },
            {
                language: 'es-ES',
                message: 'Es necesario finalizar la configuración de NFSe para realizar esta operación.',
            },
            {
                language: 'pt-BR',
                message: 'É necessário finalizar a configuração da NFSe para realizar essa operação.',
            },
        ],
        technicalMessage: 'É necessário finalizar a configuração da NFSe para realizar essa operação',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_GENERATION_DISABLED: {
        code: 'NFSE_VALIDATION_GENERATION_DISABLED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A geração da NFSe está desativada. Ative a geração nas configurações.',
            },
            {
                language: 'en-US',
                message: 'NFSe generation is disabled. Enable generation in settings.',
            },
            {
                language: 'es-ES',
                message: 'La generación de NFSe está desactivada. Active la generación en la configuración.',
            },
            {
                language: 'pt-BR',
                message: 'A geração da NFSe está desativada. Ative a geração nas configurações.',
            },
        ],
        technicalMessage: 'A geração da NFSe está desativada',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_CEP_QUERY_ERROR: {
        code: 'NFSE_VALIDATION_CEP_QUERY_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não foi possível consultar o CEP informado. Verifique a conexão e tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Não foi possível consultar o CEP informado. Verifique a conexão e tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Unable to query the provided ZIP code. Check your connection and try again.',
            },
            {
                language: 'es-ES',
                message: 'No se pudo consultar el código postal informado. Verifique la conexión e intente nuevamente.',
            },
        ],
        technicalMessage: 'Falha ao consultar os dados vinculados ao CEP',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_RPS_NUMBER_NOT_FOUND: {
        code: 'NFSE_VALIDATION_RPS_NUMBER_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Numeração do RPS não configurada. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Numeração do RPS não configurada. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'RPS numbering not configured. Please check the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'Numeración de RPS no configurada. Verifique la configuración de facturas.',
            },
        ],
        technicalMessage: 'Não foi possível identificar a numeração do RPS na configuração da empresa',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_DPS_NUMBER_NOT_FOUND: {
        code: 'NFSE_VALIDATION_DPS_NUMBER_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Numeração da DPS não configurada. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Numeração da DPS não configurada. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'DPS numbering not configured. Please check the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'Numeración de DPS no configurada. Verifique la configuración de facturas.',
            },
        ],
        technicalMessage: 'Não foi possível identificar a numeração da DPS na configuração da empresa',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_COMMUNICATION_RULE_NOT_CONFIGURED: {
        code: 'NFSE_VALIDATION_COMMUNICATION_RULE_NOT_CONFIGURED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Regra de comunicação para NFS-e não configurada. Verifique as configurações da empresa.',
            },
            {
                language: 'pt-BR',
                message: 'Regra de comunicação para NFS-e não configurada. Verifique as configurações da empresa.',
            },
            {
                language: 'en-US',
                message: 'NFS-e communication rule not configured. Please check the company settings.',
            },
            {
                language: 'es-ES',
                message: 'Regla de comunicación para NFS-e no configurada. Verifique la configuración de la empresa.',
            },
        ],
        technicalMessage: 'Regra de comunicação para NFSe não configurada.',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_SERIES_MISSING: {
        code: 'NFSE_VALIDATION_SERIES_MISSING',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A série da nota fiscal não foi informada. Verifique as configurações de emissão.',
            },
            {
                language: 'pt-BR',
                message: 'A série da nota fiscal não foi informada. Verifique as configurações de emissão.',
            },
            {
                language: 'en-US',
                message: 'Invoice series not provided. Please check the issuance settings.',
            },
            {
                language: 'es-ES',
                message: 'La serie de la factura no fue informada. Verifique la configuración de emisión.',
            },
        ],
        technicalMessage: 'Serie não informada no JSON',
        severity: 'error',
        critical: false,
    },
    NFSE_VALIDATION_MISSING_REQUIRED_PARAMS: {
        code: 'NFSE_VALIDATION_MISSING_REQUIRED_PARAMS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Há parâmetros obrigatórios ausentes. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Há parâmetros obrigatórios ausentes. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'Required parameters are missing. Please check the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'Faltan parámetros obligatorios. Verifique la configuración de facturas.',
            },
        ],
        technicalMessage: 'Operação interrompida pela ausência de parâmetros obrigatórios',
        severity: 'error',
        critical: false,
    },
};
